"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBTITLE = exports.TITLE = void 0;
var react_1 = __importDefault(require("react"));
var typography_1 = require("../../typography");
var ContentfulRichText_1 = __importDefault(require("../../utils/ContentfulRichText"));
var Markdown_1 = __importDefault(require("../../utils/Markdown"));
var styles_1 = require("./styles");
exports.TITLE = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
};
exports.SUBTITLE = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '3',
    '5': '4',
};
var Lockup = function (_a) {
    var title = _a.title, titleMaxWidth = _a.titleMaxWidth, _b = _a.titleColor, titleColor = _b === void 0 ? 'BLUE_50' : _b, subtitle = _a.subtitle, subtitleMarkdown = _a.subtitleMarkdown, subtitleRichText = _a.subtitleRichText, subtitleMaxWidth = _a.subtitleMaxWidth, _c = _a.subtitleColor, subtitleColor = _c === void 0 ? 'GREY_90' : _c, _d = _a.align, align = _d === void 0 ? 'center' : _d, _e = _a.level, level = _e === void 0 ? '1' : _e, commonProps = __rest(_a, ["title", "titleMaxWidth", "titleColor", "subtitle", "subtitleMarkdown", "subtitleRichText", "subtitleMaxWidth", "subtitleColor", "align", "level"]);
    var RICH_TEXT_1_OVERRIDES = react_1.default.useMemo(function () { return ({
        paragraph: function (_, children) { return (react_1.default.createElement(typography_1.Body, { color: subtitleColor, level: exports.SUBTITLE[level], maxWidth: subtitleMaxWidth }, children)); },
    }); }, [subtitleColor, level, subtitleMaxWidth]);
    var MARKDOWN_1_OVERRIDES = react_1.default.useMemo(function () { return ({
        p: function (_a) {
            var children = _a.children;
            return (react_1.default.createElement(typography_1.Body, { color: subtitleColor, level: exports.SUBTITLE[level], maxWidth: subtitleMaxWidth }, children));
        },
    }); }, [subtitleColor, level, subtitleMaxWidth]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "Lockup" }, commonProps, { "$align": align, level: level }),
        react_1.default.createElement(typography_1.Heading, { level: exports.TITLE[level], maxWidth: titleMaxWidth, color: titleColor }, title),
        subtitle && (react_1.default.createElement(typography_1.Body, { color: subtitleColor, level: exports.SUBTITLE[level], maxWidth: subtitleMaxWidth }, subtitle)),
        subtitleMarkdown && react_1.default.createElement(Markdown_1.default, { overrides: MARKDOWN_1_OVERRIDES }, subtitleMarkdown),
        subtitleRichText && (react_1.default.createElement(ContentfulRichText_1.default, { nodeOverrides: RICH_TEXT_1_OVERRIDES }, subtitleRichText))));
};
exports.default = Lockup;
